// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LoadingIcon from '../../../LoadingIcon';
import { actionCreatorsList } from '../../../../redux/rootActionCreator';
import ChallengeSelector from '../../../../redux/selectors/ChallengeSelector';
import { CompletionStatusType } from '../../../../types/Model';

import { S } from './styles';

interface ChallengeModuleProps {
  id: number;
  status?: CompletionStatusType;
  courseId: number;
  courseType: string;
  triggerProgress: () => void;
  handleNextModule: () => void;
}

function useGetChallengeInformation(id: number) {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getChallengeInformationActions.request({
      id,
      condition: 'buy'
    }))
  }, [id]);
}

const ChallengeContent: React.FC<ChallengeModuleProps> = ({ id, status, triggerProgress, handleNextModule, courseId, courseType }): JSX.Element => {
  const challenge = useSelector(ChallengeSelector.makeChallengeByIdSelector(id));
  const isChallengeFetching = useSelector(ChallengeSelector.makeIsFetchingChallenge());
  const fromWorkshop = courseType === 'workshops' ? `?workshopId=${courseId}` : ''
  const fromCourse = courseType === 'onlineCourses' ? `?courseId=${courseId}` : ''
  const fromIltCourse = courseType === 'iltCourses' ? `?iltCourseId=${courseId}` : ''
  const challengeUrl = `/challenges/${id}${fromWorkshop}${fromCourse}${fromIltCourse}`

  const getChallengeInformation = useGetChallengeInformation(id);

  useEffect(() => {
    getChallengeInformation();
  }, [id])

  if (isChallengeFetching) {
    return (
      <S.Container>
        <LoadingIcon size={15} />
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.Row>
        <S.InformationContainer>
          <S.Title><FormattedMessage id="F041" />{challenge.name}</S.Title>
          <S.Overview>{challenge.overview}</S.Overview>
        </S.InformationContainer>
        <S.ChallengeImage />
      </S.Row>
      <S.Row>
        <S.Button as={Link} to={challengeUrl} target="_blank"><FormattedMessage id="F040" /></S.Button>
        {status === CompletionStatusType.COMPLETED && <S.Button onClick={handleNextModule}><FormattedMessage id="F015" /></S.Button>}
      </S.Row>
    </S.Container>
  );
}

export { ChallengeContent as default };
